import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import CommentFormCategories from "./forms/CommentFormCategories";
import { useDispatch, useSelector } from "react-redux";
import Controls from "./controls";
import { findIndex, isEmpty } from "lodash";
import moment from "moment";
import {
  Fab,
  Paper,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  IconButton,
} from "@material-ui/core";

import Iconify from "./Iconify.js";
import MaterialTable from "material-table";
import Api from "../lib/api";
import useTable from "./useTable";
import Popup from "./Popup";
import { fetchEntitiesService as fetchCommentCategoriesService } from "../redux/slices/commentCategoriesSlice.js";
import CRMUtils from "../utils/index.js";
import ConfirmDialog from "./ConfirmDialog.js";
import CommentsUtils from "../utils/comments.js";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(1) / 4}px
    ${(props) => props.theme.spacing(4)}px;
  flex-direction: column;
  display: flex;
  height: 100%;
`;

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "6px 16px",
    flexGrow: 1,
  },
  form: {
    justifySelf: "self-end",
  },
}));

var dataSliceCommentCategories = {
  stateListName: "commentCategories",
  dataUrl: {},
  orgId: 1,
  getFilters: {
    include: [],
    params: [],
    filters: [],
  },
  dataList: {
    showPageLoading: false,
    successHandle: null,
  },
};

function CommentsContact(props) {
  const classes = useStyles();
  const {
    contact_id,
    rReadonly = false,
    readonly = false,
    canAdd = true,
    editableNoDoctor = false,
    consultantErrorHandle = null,
  } = props;
  const dispatch = useDispatch();
  const { commentCategories } = useSelector((state) => state.commentCategories);
  const { authUser } = useSelector((state) => state.auth);
  const [confirmDialogLoading, setConfirmDialogLoading] = useState(false);
  const [commentForEdit, setCommentForEdit] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });

  const openInPopup = (item = null) => {
    setOpenPopup(true);
    setCommentForEdit(item);
  };

  const onClose = () => {
    setOpenPopup(false);
    setCommentForEdit(null);
  };
  const [comment, setComment] = useState([]);
  const [commentL, setCommentL] = useState([]);
  const { TblContainer } = useTable();
  const [openPopup, setOpenPopup] = useState(false);
  const [filterCategories, setFilterCategories] = useState(null);

  const saveComment = async (payload) => {
    try {
      if (commentForEdit) {
        const { data } = await Api.updateComment(commentForEdit.id, payload);

        const index = findIndex(commentL, ["id", data.data.id]);
        const updatedEvent = {
          ...commentL[index],
          ...data.data,
        };

        let newComments = [...commentL];
        newComments[index] = updatedEvent;
        setCommentL([...newComments]);
        setCommentForEdit(null);
        onClose();
      } else {
        const { data } = await Api.createContactComment(contact_id, payload);
        setComment([data.data, ...comment]);
        onClose();
      }
    } catch (e) {
      if (typeof consultantErrorHandle === "function") {
        consultantErrorHandle(e?.data?.message || "Something went wrong!");
      }
    }
  };
  const [progressBar, setProgressBar] = useState(false);

  useEffect(() => {
    if (contact_id) {
      setProgressBar(true);
      commentsFunc().then(function () {
        setProgressBar(false);
      });
    }
  }, [contact_id]);

  useEffect(() => {
    if (filterCategories && filterCategories > 0) {
      setCommentL(
        comment.filter((e) => {
          return e.comment_category_id === filterCategories;
        })
      );
    } else if (filterCategories && filterCategories == -2) {
      setCommentL(
        comment.filter((e) => {
          return e.comment_category_id == null;
        })
      );
    } else {
      setCommentL(comment);
    }
  }, [filterCategories, comment]);

  useEffect(() => {
    dispatch(fetchCommentCategoriesService(dataSliceCommentCategories));
  }, []);

  const commentsFunc = async () => {
    try {
      const { data } = await Api.getContactComments(contact_id);
      setComment(data.data);
    } catch (e) {
      console.log(e);
      if (typeof consultantErrorHandle === "function") {
        consultantErrorHandle(e?.data?.message || "Something went wrong!");
      }
    }
  };

  const openConfirmDialog = (
    setConfirmDialogObj,
    onConfirmHandle,
    onConfirmParam,
    title,
    subtitle = null
  ) => {
    setConfirmDialogObj({
      isOpen: true,
      title: title,
      subTitle: subtitle ? subtitle : "You can't undo this operation",
      onConfirm: () => onConfirmHandle(onConfirmParam),
    });
  };

  const closeConfirmDialog = (setConfirmDialogObj, confirmDialogObj) => {
    setConfirmDialogObj({
      ...confirmDialogObj,
      isOpen: false,
    });
  };

  const deleteComment = async (id) => {
    try {
      setConfirmDialogLoading(true);
      await Api.deleteComment(id);
      setCommentL(commentL.filter((c) => c.id != id));
    } catch (e) {
      if (typeof consultantErrorHandle === "function") {
        consultantErrorHandle(e?.data?.message || "Something went wrong!");
      }
    } finally {
      setConfirmDialogLoading(false);
      closeConfirmDialog(setConfirmDialog, confirmDialog);
    }
  };

  const onClickOnDelete = (id) => {
    openConfirmDialog(
      setConfirmDialog,
      deleteComment,
      id,
      "Are you sure to delete the comment?"
    );
  };

  // const dataMaterialTable = [];
  const dataMaterialTable = commentL ? commentL.map((o) => ({ ...o })) : [];

  const headCellsMaterial = [
    {
      field: "comment",
      title: "Comment",
      render: (rowData) => (
        <ListItemText
          primary={`${rowData?.comment}`}
          primaryTypographyProps={{
            style: {
              whiteSpace: "normal",
              wordWrap: "break-word",
              maxWidth: "370px",
              fontFamily:
                '"Google Sans",Roboto,RobotoDraft,Helvetica,Arial,sans-serif',
            },
          }}
        />
      ),
    },
    {
      field: "user_id",
      title: "Created By",
      render: (rowData) => {
        return rowData.user && !isEmpty(rowData.user.data) ? (
          <ListItemText
            primary={`${rowData?.user?.data?.title}`}
            secondary={`${rowData?.user?.data?.building_name} - ${rowData?.user?.data?.department_name}`}
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "category",
      title: "Category",
      render: (rowData) => {
        return (
          <ListItem>
            <ListItemIcon>
              <Box
                style={{
                  width: 20,
                  height: 20,
                  display: "flex",
                  borderRadius: "50%",
                  position: "relative",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: `${rowData.commentCategoryColor}`,
                }}
              />
            </ListItemIcon>
            <ListItemText primary={`${rowData.commentCategoryName}`} />
          </ListItem>
        );
      },
    },
    {
      field: "created_at",
      title: "Created",
      render: (rowData) => {
        return new moment(rowData.created_at).format("YYYY-MM-DD HH:mm:ss");
      },

      customSort: (a, b) =>
        new Date(
          moment(a.created_at).utc().format("YYYY-MM-DD HH:mm:ss")
        ).getTime() -
        new Date(
          moment(b.created_at).utc().format("YYYY-MM-DD HH:mm:ss")
        ).getTime(),
    },
  ];

  const getCommentCategoriesOptions = () => {
    let commentCategoriesLocal = [];
    commentCategoriesLocal.push({
      id: -1,
      title: "-------",
      color: "#000000",
    });
    commentCategoriesLocal.push({
      id: -2,
      title: "No Category",
      color: "#e0e0e0",
    });

    commentCategories.forEach((e) => {
      var opt = {
        id: e.id,
        title: e.name,
        color: e.color,
      };
      commentCategoriesLocal.push(opt);
    });

    return commentCategoriesLocal;
  };

  return (
    <Wrapper>
      <Paper elevation={1} className={classes.paper}>
        <div style={{ display: "flex", position: "relative" }}>
          <div
            style={{
              position: "absolute",
              zIndex: 1000,
              top: "20px",
              right: "445px",
              width: "200px",
            }}
          >
            <Controls.SelectWColor
              label="Category"
              value={filterCategories}
              options={getCommentCategoriesOptions()}
              onChange={(newValue) => {
                setFilterCategories(newValue.target.value);
              }}
              disabled={progressBar}
              variant="standard"
            />
          </div>
        </div>
        <TblContainer>
          <MaterialTable
            isLoading={progressBar}
            columns={headCellsMaterial}
            data={dataMaterialTable}
            options={{
              loadingType: "linear",
              pageSize: 10, // make initial page size
              emptyRowsWhenPaging: false, //to make page size fix in case of less data rows
              actionsColumnIndex: -1,
              sorting: true,
            }}
            actions={[
              {
                icon: () => (
                  <Fab color="primary" aria-label="add">
                    <Iconify
                      icon={"fluent:add-12-filled"}
                      width={25}
                      height={25}
                    />
                  </Fab>
                ),
                tooltip: "Add Comment",
                disabled: !canAdd || readonly,
                hidden: !canAdd || readonly,
                isFreeAction: true,
                onClick: (event) => {
                  openInPopup();
                },
              },
              {
                action: (rowData) => {
                  return {
                    icon: () => (
                      <IconButton color="primary" aria-label="add">
                        <Iconify
                          icon={"ic:outline-edit"}
                          width={22}
                          height={22}
                        />
                      </IconButton>
                    ),
                    tooltip: "Edit",
                    hidden: !CommentsUtils.userCanEditComment(
                      authUser,
                      rowData
                    ),
                    onClick: (event) => {
                      openInPopup(rowData);
                    },
                    position: "row",
                  };
                },
              },
              {
                action: (rowData) => {
                  return {
                    icon: () => (
                      <IconButton color="primary" aria-label="add">
                        <Iconify
                          style={{ color: "red" }}
                          icon={"mdi:trash"}
                          width={22}
                          height={22}
                        />
                      </IconButton>
                    ),
                    tooltip: "Delete",
                    hidden: !CommentsUtils.userCanDeleteComment(
                      authUser,
                      rowData
                    ),
                    onClick: (event) => {
                      onClickOnDelete(rowData.id);
                    },
                    position: "row",
                  };
                },
              },
            ]}
            title="Comments"
          />
        </TblContainer>
      </Paper>

      <Popup
        title={commentForEdit ? "Edit comment" : "Add comment"}
        fullWidth={true}
        openPopup={openPopup}
        onClose={onClose}
      >
        <CommentFormCategories
          commentForEdit={commentForEdit}
          saveComment={saveComment}
          className={classes.form}
          canAdd={canAdd}
          readonly={readonly}
          //rReadonly={rReadonly}
          editableNoDoctor={editableNoDoctor}
          commentCategories={commentCategories}
        />
      </Popup>
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
        confirmLoading={confirmDialogLoading}
      />
    </Wrapper>
  );
}

export default CommentsContact;
